// CustomSidebar.js
import React from "react";
import {
  FaBars,
  FaHome, // For Dashboard Home
  FaCreditCard,
  FaUsers,
  FaBuilding,
  FaFileContract,
  FaChartBar,
  FaCog,
} from "react-icons/fa";
// import Logo from "../assets/Group 1261153494.png";
import Logo from "../assets/RentPeLogo.png";
import Logo_1 from "../assets/Logo_1.png";

import { NavLink, Link, useLocation } from "react-router-dom"; // Added useLocation

// Define menu items based on App.js routes
// All these routes are nested under the "/dashboard" base path
const menuItems = [
  { to: "/dashboard", label: "Home", icon: FaHome, exact: true }, // 'exact' helps NavLink for index routes
  { to: "/dashboard/reports", label: "Reports", icon: FaChartBar },
  { to: "/dashboard/agreements", label: "Agreements", icon: FaFileContract },

  { to: "/dashboard/payments", label: "Payments", icon: FaCreditCard },
  {
    to: "/dashboard/tenants-list",
    label: "Tenants",
    icon: FaUsers,
  }, // Assuming this is the desired path
  { to: "my-properties", label: "Properties", icon: FaBuilding },

  // { to: "/dashboard/settings", label: "Settings", icon: FaCog }, // Example for a settings link under dashboard
];

export default function CustomSidebar({ collapsed, toggleSidebar }) {
  const location = useLocation(); // For more precise active link matching if needed

  return (
    <aside
      className={`fixed top-0 left-0 h-full z-40 text-gray-100
                 bg-gradient-to-b from-blue-600 to-blue-800 shadow-lg 
                 transition-all duration-300 ease-in-out
                 ${collapsed ? "w-[80px]" : "w-64"}`}
    >
      {/* Header: Logo and Toggle Button */}
      <div
        className={`flex items-center h-16 px-4 border-b border-blue-500/50
                     ${collapsed ? "justify-center" : "justify-between"}`}
      >
        {!collapsed && (
          // Logo should link to the main dashboard page when sidebar is part of authenticated layout
          <Link to="/dashboard" className="flex items-center">
            {/* <img src={Logo} alt="RentPe Logo" className="h-8 w-auto" /> */}
            {/* <img src={Logo} alt="RentPe Logo" className="h-8 w-auto" /> */}
            <img src={Logo_1} alt="RentPe Logo" className="h-8 w-auto" />
          </Link>
        )}
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-md text-gray-200 hover:bg-blue-700/50 focus:outline-none focus:ring-2 focus:ring-blue-400"
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <FaBars className="w-5 h-5" />
        </button>
      </div>

      {/* Navigation Links */}
      <nav className="flex-grow p-4 space-y-1 overflow-y-auto">
        {" "}
        {/* Added overflow-y-auto */}
        {menuItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            // `end` prop is important for NavLink to correctly match child routes.
            // For "/dashboard", `end` makes it active only for "/dashboard", not "/dashboard/payments".
            // For "/dashboard/my-properties", if you don't use `end`, it will also be active for "/dashboard/my-properties/tenants-list".
            // Decide based on desired active state behavior. Generally, `end` is good for parent links.
            end={item.exact || item.to === "/dashboard/my-properties"} // Example: make "Properties" exact if it shouldn't stay active for "Tenants"
            className={({ isActive }) =>
              `flex items-center py-2.5 px-4 rounded-md text-sm font-medium transition-colors duration-150 ease-in-out
               hover:bg-blue-700/60 hover:text-white
               ${isActive ? "bg-blue-700 text-white shadow-inner" : "text-blue-100"}
               ${collapsed ? "justify-center" : ""}`
            }
            title={collapsed ? item.label : undefined}
          >
            <item.icon className={`w-5 h-5 ${!collapsed ? "mr-3" : ""}`} />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <footer
        className={`absolute bottom-0 left-0 w-full p-4 border-t border-blue-500/50
                        ${collapsed ? "text-center" : ""}`}
      >
        {!collapsed ? (
          <>
            <Link
              to="/privacy-policy" // This is a public, top-level route
              className="text-xs text-blue-200 hover:text-white block mb-1 text-center"
            >
              Privacy Policy
            </Link>
            <p className="text-xs text-blue-300 text-center">
              © {new Date().getFullYear()} RentPe. All rights reserved.
            </p>
          </>
        ) : (
          // If you have a settings page under dashboard:
          // <Link
          //   to="/dashboard/settings"
          //   title="Settings"
          //   className="flex justify-center text-blue-200 hover:text-white"
          // >
          //   <FaCog className="w-5 h-5" />
          // </Link>
          // Or if privacy policy is more important here:
          <Link
            to="/privacy-policy"
            title="Privacy Policy"
            className="flex justify-center text-blue-200 hover:text-white"
          >
            {/* You might need a different icon for privacy policy if FaCog is settings */}
            <FaFileContract className="w-5 h-5" />
          </Link>
        )}
      </footer>
    </aside>
  );
}
